<template>
  <div class="pageContent">
    <topHeader :detail="deviceDetail" type="device"></topHeader>
    <!-- 页面头部显示设备信息 -->
    <!-- <el-row :span="24" type="flex">
      <el-col :span="12" class="messageCon">
        <el-col :span="8">
          <span>自定义名称</span>&nbsp;&nbsp;&nbsp;&nbsp;测试空调
        </el-col>
        <el-col :span="8">
           <el-button size="mini" type="primary">空闲</el-button>
           <el-button size="mini">在控</el-button>
        </el-col>
        <el-col :span="8" class="tx-r">
          <el-button size="small" @click="showDeviceDetail">设备信息</el-button>
        </el-col>
        <el-col :span="8">
          <span class="el-icon-location"></span>----
        </el-col>
        <el-col :span="8">
          <span>登录账号：</span>admin
        </el-col>
      </el-col>
      <img :src="airConditionImg" height="100px" alt="" srcset="">
      <div class="deviceDetail">
        <p><span>区域</span>：华南</p>
         <p><span>省市</span>：广东</p>
          <p><span>设备S/N</span>：00fbfca7bf0000000000000101044949</p>
      </div>
    </el-row> -->
    <el-row :span='24' class="topView">
      <el-col :span="3">产品</el-col>
      <el-col :span="9">{{deviceDetail.productName}}<span class="btn" @click="goProduct">查看</span></el-col>
      <el-col :span="3" v-if="deviceDetail.deviceSecret">DeviceSecret</el-col>
      <el-col :span="9" v-if="deviceDetail.deviceSecret">********<span class="btn" @click="secretParams.secretVisible=true">查看</span></el-col>
      <el-col :span="3">productKey</el-col>
      <el-col :span="9">{{deviceDetail.productKey}}<span class="btn" @click="copy(deviceDetail.productKey)">复制</span></el-col>
    </el-row>

    <!-- tab切换头部 -->
    <el-tabs type="border-card"   v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane label="设备信息" name="0">
         <keep-alive>
           <!-- 切换到对应的tab再加载组件，keep-alive保证重新切换回来不会重新加载 -->
          <detailView :data="deviceDetail" v-if="activeName==='0' && deviceDetail.deviceSecret"></detailView>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="Topic 列表" name="1">
         <keep-alive>
          <deviceTopicView v-if="deviceDetail.deviceName && activeName==='1'" :deviceDetail="deviceDetail"></deviceTopicView>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="物模型数据" name="2">
        <!-- 保证详情数据获取到得情况下，再加载组件 -->
         <keep-alive>
          <objectModelView v-if="deviceDetail.deviceName && activeName==='2'" :deviceDetail="deviceDetail"></objectModelView>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="消息记录" name="3">
         <keep-alive>
          <mesRecord
            v-if="deviceDetail.deviceName && activeName==='3'"
            :productKey="deviceDetail.productKey"
            :deviceName="deviceDetail.deviceName">
          </mesRecord>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="上下线记录" name="4">
         <keep-alive>
          <onlineRecord
           v-if="deviceDetail.deviceName && activeName==='4'"
           :productKey="deviceDetail.productKey"
           :deviceName="deviceDetail.deviceName">
          </onlineRecord>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="设备文件列表" name="5">
          <deviceLog
           v-if="deviceDetail.deviceName && activeName==='5'"
           :deviceStatus ="deviceDetail.deviceStatus"
           :productKey="deviceDetail.productKey"
           :deviceName="deviceDetail.deviceName">
          </deviceLog>
      </el-tab-pane>
      <el-tab-pane label="窗帘页面" name="6" v-if="deviceDetail.productKey === 'a194FDVK89n'">
          <curtain
           v-if="deviceDetail.deviceName && activeName==='6'"
           :productKey="deviceDetail.productKey"
           :deviceName="deviceDetail.deviceName">
          </curtain>
      </el-tab-pane>
      <el-tab-pane label="子设备管理" name="7" v-if="deviceDetail.nodeType === 2">
          <sonDevice
           v-if="deviceDetail.deviceName && activeName==='7'"
           :productKey="deviceDetail.productKey"
           :deviceName="deviceDetail.deviceName">
          </sonDevice>
      </el-tab-pane>
    </el-tabs>

    <!-- 设备证书弹窗 -->
    <deviceSecretView
    :close-view="secretParams.introduceVisible = false"
    :deviceDetail="deviceDetail"
    :secretParams="secretParams">
    </deviceSecretView>

  </div>
</template>
<script>
import objectModelView from '@/components/deviceManage/objectModelView'
import detailView from '@/components/deviceManage/detailView'
import deviceSecretView from '@/components/deviceManage/deviceSecretView'
import deviceLog from '@/components/deviceManage/deviceLog'
import curtain from '@/components/deviceManage/curtainPage'
import sonDevice from '@/components/deviceManage/sonDevice'
import mesRecord from '@/components/systemOperation/mesRecord'
import onlineRecord from '@/components/systemOperation/onlineRecord'
import deviceTopicView from '@/components/deviceManage/deviceTopicView'
import topHeader from '@/components/header'
import { deviceDetail as requestDetail } from '@/api/deviceManagement'
import { copy } from '@/utils'
import { eventBus } from '@/utils/eventBus'
import { mapGetters } from 'vuex'
export default {
  components: {
    objectModelView,
    topHeader,
    detailView,
    deviceSecretView,
    mesRecord,
    onlineRecord,
    deviceLog,
    deviceTopicView,
    curtain,
    sonDevice
  },
  watch: {
    'deviceDetail.productKey': {
      immediate: true,
      handler () {
        console.log(this.deviceDetail.productKey)
      }
    }
  },
  data () {
    return {
      dialogTableVisible: false,
      activeName: '0',
      deviceDetail: '',
      secretParams: {
        secretVisible: false,
        introduceVisible: false
      }
    }
  },
  methods: {
    handleClick (tab) {
      // 清除运行状态标签页得定时器
      tab.name !== '2'
        ? eventBus.$emit('clearFreshInterval')
        : ''
    },
    getDeviceDetail () {
      const params = {
        deviceName: this.deviceDetail.deviceName,
        productKey: this.deviceDetail.productKey
      }
      requestDetail(params).then(res => {
        res = res.data
        console.log('详情res:', res)
        res.code === 200
          ? this.deviceDetail = res.data
          : this.$message({
            showClose: true,
            message: '请求失败，请稍后重试',
            type: 'error'
          })
      })
    },
    copy (val) {
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    goProduct () {
      const infos = JSON.stringify(this.deviceDetail)
      localStorage.setItem('infos', infos)
      this.$router.push({
        path: '/productControl/productDetail',
        query: { sRow: infos }
      })
    }
  },
  created () {
    if (this.$route.params.activeName) this.activeName = this.$route.params.activeName
    if (this.localDetail) {
      this.deviceDetail = JSON.parse(this.localDetail)
      sessionStorage.setItem('getsubDeviceDetail', this.localDetail)
    } else {
      this.deviceDetail = JSON.parse(sessionStorage.getItem('getsubDeviceDetail'))
    }
    console.log(this.deviceDetail)
    /// console.log(' this.$route.params:', this.$route.params)
    this.getDeviceDetail()
    console.log('localDetail:', this.localDetail)
  },
  computed: {
    ...mapGetters({
      localDetail: 'getsubDeviceDetail'
    })
  }
}
</script>
<style lang="less" scoped>
html{
  background-color: #eaedf1;
}
.pageContent{
  margin-left: 10px;
  .topView{
    color: rgb(136, 136, 136);
    font-size: 13px;
    line-height: 25px;
    .btn{
      color: rgb(0, 112, 204);
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .el-tabs{
    margin-top: 10px;
  }
  .tx-r{
    text-align: right;
  }
  /deep/ .el-tabs--border-card{
    border: none;
    box-shadow:0 0 0 ;
  }
}
</style>
